import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('dividerSection', {
    id: {
        title: 'ID',
        type: 'string',
        hidden: true
    }
});
var validator = z.object({
    _type: z.literal('dividerSection'),
    id: z.string().optional()
});
schema.dividerSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=dividerSection.js.map